import { Injectable } from '@angular/core';
import {
  AngularFirestore
} from '@angular/fire/firestore';
import { Nomenclature } from 'src/app/shared/models/nomenclature';
import { Observable } from 'rxjs';
import { AuthProcessService } from 'ngx-auth-firebaseui';
import { AngularFireStorage, AngularFireUploadTask } from '@angular/fire/storage';
import { MatSnackBarModule } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class RequestService {
  constructor(private afs: AngularFirestore, private storage: AngularFireStorage, public authService: AuthProcessService) { }

  getLoanTypesNomenclature(): Observable<Nomenclature[]> {
    return this.afs
      .collection<Nomenclature>('loan_types', ref => ref.orderBy('order', 'asc'))
      .valueChanges();
  }

  getLoanAmountsNomenclature(loanType: string): Observable<Nomenclature[]> {
    return this.afs
      .collection('loans')
      .doc(String(loanType))
      .collection<Nomenclature>('amounts', ref => ref.orderBy('id', 'asc'))
      .valueChanges();
  }

  getLoanMonthsNomenclature(loanType: number, amount: number): Observable<any> {
    return this.afs
      .collection('loans')
      .doc(String(loanType))
      .collection<Nomenclature>('periods')
      .doc(String(amount))
      .valueChanges();
  }

  getAreasNomenclature(): Observable<Nomenclature[]> {
    return this.afs
      .collection<Nomenclature>('areas', ref => ref.orderBy('name', 'asc'))
      .valueChanges();
  }

  getCitiesNomenclature(areaId: number): Observable<any> {
    return this.afs
      .collection('areas')
      .doc(String(areaId))
      .collection<Nomenclature>('cities', ref => ref.orderBy('id', 'asc'))
      .valueChanges();
  }

  getPostCode(areaId: string, cityId: string): Observable<any> {
    return this.afs
      .collection('areas')
      .doc(String(areaId))
      .collection('cities', ref => ref.where('id', '==', cityId).limit(1))
      .valueChanges();
  }

  getOwnershipOfPropertyNomenclature(): Observable<Nomenclature[]> {
    return this.afs
      .collection<Nomenclature>('ownership_of_property', ref =>
        ref.orderBy('id', 'asc')
      )
      .valueChanges();
  }

  getEducationNomenclature(): Observable<Nomenclature[]> {
    return this.afs.collection<Nomenclature>('education', ref =>
      ref.orderBy('id', 'asc')
    ).valueChanges();
  }


  getEmploymentNomenclature(): Observable<Nomenclature[]> {
    return this.afs.collection<Nomenclature>('employment').valueChanges();
  }

  getWorkExperienceNomenclature(): Observable<Nomenclature[]> {
    return this.afs
      .collection<Nomenclature>('work_experience', ref =>
        ref.orderBy('id', 'asc')
      )
      .valueChanges();
  }

  getAreasOfOperationNomenclature(): Observable<Nomenclature[]> {
    return this.afs
      .collection<Nomenclature>('areas_of_operation', ref =>
        ref.orderBy('id', 'asc')
      )
      .valueChanges();
  }

  getEmploymentContractsNomenclature(): Observable<Nomenclature[]> {
    return this.afs
      .collection<Nomenclature>('employment_contracts', ref =>
        ref.orderBy('id', 'asc')
      )
      .valueChanges();
  }

  getJobPositionsNomenclature(): Observable<Nomenclature[]> {
    return this.afs
      .collection<Nomenclature>('job_positions', ref =>
        ref.orderBy('id', 'asc')
      )
      .valueChanges();
  }

  getHowDoYouKnowAboutUsNomenclature(): Observable<Nomenclature[]> {
    return this.afs
      .collection<Nomenclature>('how_do_you_know_about_us', ref =>
        ref.orderBy('id', 'asc')
      )
      .valueChanges();
  }

  saveData(creditData: any): Promise<any> {

    return this.afs
      .collection('credits')
      .add({ user_id: this.authService.user.uid, json: creditData, date: new Date() });
  }

  uploadFile(file: any): AngularFireUploadTask {
    let id = this.afs.createId();

    const filePath = 'id-cards/' + id + '-' + file.name;
    const ref = this.storage.ref(filePath);
    const task = ref.put(file);

    return task;

  }

  getDownloadLink(imageName: string): Observable<string | null> {
    const ref = this.storage.ref('id-cards/' + imageName);
    return ref.getDownloadURL();
  }

  deteleFile(path: string): Observable<any> {
    const ref = this.storage.ref(path).delete();
    return ref;
  }
}
